import { Box, Skeleton } from '@mui/material';

export function SummarySkeleton() {
  return (
    <Box sx={{ width: '100%' }}>
      <Skeleton variant="rectangular" height={25} sx={{ mb: 2, borderRadius: '4px' }} />
      <Skeleton variant="rectangular" height={70} sx={{ mb: 2, borderRadius: '4px' }} />
      <Skeleton variant="rectangular" height={70} sx={{ borderRadius: '4px' }} />
    </Box>
  );
}
